module.exports = __webpack_public_path__ + "static/media/sistema-comparativo.de967aca.jpg";